const StandardYoutubeVideo = {


  render: function () {

    $(".yt-video .yt-video__main").each(function () {
      var toggle = $(this).closest(".yt-video").find(".yt-video__poster");
      var player;
      let videoId = $(this).attr("id");

      player = new YT.Player(videoId, {
        videoId: videoId,
        width: 560,
        height: 316,
        playerVars: {
          autoplay: 0,
          controls: 1,
          modestbranding: 1,
          start: 0,
          rel: 0,
          fs: 0,
          cc_load_policy: 0,
          iv_load_policy: 3,
        },
        events: {
          onReady: function (e) {
            toggle.parent().addClass("ready");
            player.seekTo(0).stopVideo();
            // Fitvids
            player.seekTo(0).stopVideo();
            toggle.click(function () {
              player.seekTo(0).playVideo();
              toggle.parent().addClass("playing");
            });
            toggle
              .closest(".yt-video")
              .find(".yt-video__close")
              .click(function () {
                toggle.parent().removeClass("playing");
                setTimeout(function () {
                  player.stopVideo();
                }, 600);
              });
            $(document).keyup(function (e) {
              if (e.key === "Escape" && toggle.parent().hasClass("playing")) {
                toggle.parent().removeClass("playing");
                setTimeout(function () {
                  player.stopVideo();
                }, 600);
              }
            });
          },
        },
      });


      const popupWrap = $(".warranty-video-popup-wrap");

      if (!popupWrap.length > 0) {
        return
      }

      const closeBtn = $(".warranty-video-popup__close");
      const backdrop = $(".warranty-video-popup-wrap__backdrop");

      closeBtn.on("click", function () {
        player.stopVideo();
        popupWrap.addClass("hidden");
      })

      backdrop.on("click", function () {
        player.stopVideo();
        popupWrap.addClass("hidden");
      })
    });
  },
};

export default StandardYoutubeVideo;